import BackendProvider from '../../services/BackendProvider'
import { DEFAULT_AVATAR } from '../../const'

export default {
    namespaced: true,
    state: () => ({
        user: {},
        selectedTenant: {},
        showLoader: false,
        fdaUnfriendlyBannerWasShown: false
    }),
    getters: {
        isUS: state => state.selectedTenant.country === 'US',
        isFdaFriendly: state =>
            state.selectedTenant.settings && !state.selectedTenant.settings.isAiActive,
        isFdaUnfriendly: (state, getters) => getters.isUS && !getters.isFdaFriendly,
        fdaUnfriendlyDisclaimerIsShown: (state, getters) =>
            getters.isFdaUnfriendly && !state.fdaUnfriendlyBannerWasShown,
        mode: state =>
            (state.selectedTenant.settings && state.selectedTenant.settings.mode) || 'timelapse', // 2d
        getTenant: state => {
            if (state.selectedTenant._id) return state.selectedTenant
            else return (state.user.tenants && state.user.tenants[0]) || {}
        },
        isCycleDetailsEnabled: (state, getters) => {
            return getters.getTenant.settings && getters.getTenant.settings.showCycleDetails
        },
        getAvatarUrl: state => {
            const { imageUrl } = state.user
            const noImage = !imageUrl || imageUrl === 'empty' || imageUrl.includes('licdn.com')

            return noImage ? DEFAULT_AVATAR : imageUrl
        },
        showDemoDisclaimer: (state, getters) => {
            const DEMO_CLINICS = [
                { name: 'iakentro_dev', _id: '642561dffb4f1186f67027d3' },
                { name: 'persona_dev', _id: '642a86edfb4f1186f67027e4' },
                { name: 'esco_clinic', _id: '63edf27aee4c8f7accea9074' },
                { name: 'Esco_dev', _id: '6425843982abcf1903963b49' }
            ]

            return DEMO_CLINICS.map(clinic => clinic._id).includes(getters.getTenant._id)
        }
    },
    mutations: {
        user(state, user) {
            state.user = user
        },
        setSelectedTenant(state, tenant) {
            state.selectedTenant = tenant || {}
        },
        showLoader(state, status) {
            state.showLoader = status
        },
        fdaUnfriendlyBannerWasShown(state, status) {
            state.fdaUnfriendlyBannerWasShown = status
        }
    },
    actions: {
        async setUserData({ commit }) {
            const user = await BackendProvider.fetchUserData()
            commit('user', user)
        },
        resetSession({ commit }) {
            commit('user', {})
            commit('setSelectedTenant', null)
            commit('showLoader', false)
        }
    }
}
